import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

const BrandedImageSliderContainer = styled.div`
    margin-bottom: 50px;
    .title-container {
        text-align: center;
        margin-bottom: 30px;
        ${media.large`max-width: 570px;`}
        h3 {
            font-size: 2.2rem;
            color: #000;
            font-weight: 800;
            margin: 0;
            font-family: neue-kabel, sans-serif;
        }
    }

    .branded-slider-wrapper {
        .slide-item-container {
            .gatsby-image-wrapper {
                max-width: 300px;
                margin: 0 auto;
            }
        }
    }
`;

const BrandedImageSlider = ({ content }) => {
    const { brandedImageSlider, sectionTitle } = content || {};

    const sliderRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(0);
    const [updateCount, setUpdateCount] = useState(0);

    var settings = {
        dots: false,
        speed: 3000,
        infinite: true,
        fade: false,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 2,
        centerMode: true,
        // autoplay: true,
        autoplay: false,
        autoplaySpeed: 2000,
        afterChange: () => setUpdateCount(updateCount + 1),
        beforeChange: (current, next) => setSlideIndex(next),
    };

    function pauseSlider() {
        console.log('pause');
        // sliderRef.current.slickPause();
    }

    function playSlider() {
        sliderRef.current.play();
    }

    return (
        <BrandedImageSliderContainer>
            <Wrapper className="title-container">
                <h3>{sectionTitle}</h3>
            </Wrapper>
            <Wrapper className="branded-slider-wrapper">
                <div className="slider-container">
                    <Slider ref={sliderRef} {...settings}>
                        {brandedImageSlider &&
                            brandedImageSlider.map((slide, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="slide-item-container"
                                    >
                                        <Img
                                            fluid={
                                                slide.image.localFile
                                                    .childImageSharp.fluid
                                            }
                                        />
                                    </div>
                                );
                            })}
                    </Slider>
                </div>
            </Wrapper>
        </BrandedImageSliderContainer>
    );
};

export default BrandedImageSlider;
